<template>
  <v-dialog
    :value="isOpen"
    :fullscreen="isFullscreen"
    @input="handleInputChange"
    v-bind="currentDialogProps || { width: '600px' }"
    content-class="overflow-visible"
  >
    <component :is="currentComponent" v-bind="currentProps"></component>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import CustomDialog from '@/components/dialogs/CustomDialog';
import RejectionDialog from '@/components/dialogs/storeModal/modal/RejectionDialog';
import PauseDialog from '@/components/dialogs/storeModal/modal/PauseDialog';
import RequestAffectationDialog from '@/components/dialogs/storeModal/modal/RequestAffectationDialog';
import WorkorderReportDialog from '@/components/dialogs/storeModal/modal/WorkorderReportDialog';
import UploadDocumentDialog from '@/components/dialogs/storeModal/modal/UploadDocumentDialog';
import ActionplanFormDialog from '@/components/dialogs/storeModal/modal/ActionplanFormDialog';
import AddRequestDialog from '@/components/dialogs/storeModal/modal/AddRequestDialog';
import ActionFormDialog from '@/components/dialogs/storeModal/modal/ActionFormDialog';
import UserExchangeFormDialog from '@/components/dialogs/storeModal/modal/UserExchangeFormDialog';
import SetupParamsDialog from '@/components/dialogs/storeModal/modal/SetupParamsDialog';

const { mapGetters, mapActions } = createNamespacedHelpers('modal');

export default {
  name: 'CustomStoreDialog',
  components: {
    CustomDialog,
    RejectionDialog,
    UserExchangeFormDialog,
    PauseDialog,
    RequestAffectationDialog,
    WorkorderReportDialog,
    ActionplanFormDialog,
    ActionFormDialog,
    UploadDocumentDialog,
    AddRequestDialog,
    SetupParamsDialog,
  },
  data() {
    return {
      currentComponent: null,
      currentProps: null,
      currentDialogProps: null,
    };
  },
  computed: {
    ...mapGetters([
      'isOpen',
      'component',
      'componentProps',
      'isFullscreen',
      'dialogProps',
    ]),
  },
  methods: {
    ...mapActions(['hideModal']),
    handleInputChange(val) {
      if (!val) this.hideModal();
    },
  },
  watch: {
    component(componentName) {
      if (!componentName) return;
      this.currentComponent = componentName;
    },
    componentProps: {
      handler(newVal) {
        this.currentProps = newVal;
      },
      deep: true,
    },
    dialogProps(newVal) {
      this.currentDialogProps = newVal;
    },
  },
};
</script>
